export default "__VITE_ASSET__e0827e23__"